import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RcmsStorage, BaseResourceService } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class RcmsStorageService extends BaseResourceService<RcmsStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`rcms-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, rcms: number, descricao?: string, assinatura?: boolean): Observable<RcmsStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }
    if (assinatura) {
      formData.append('assinatura', 'true');
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<RcmsStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${rcms}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public downloadArquivo(url: string): Observable<any> {

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');
    headers['responseType'] = 'blob';

    url = url.replace(/([^:]\/)\/+/g, '$1');
    const encodedUrl = encodeURIComponent(url);

    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/download-arquivo?url=${encodedUrl}`, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
